(function () {

    'use strict';

    angular
        .module('glossaryTermEditModule')
        .controller('GlossaryTermAddController', Controller);

    Controller.$inject = ['$scope', 'topBarService'];

    function Controller($scope, topBarService) {
            
        topBarService.setTitleAndIcon('Add Glossary Term', 'fa fa-university');
        $scope.glossaryTerm = {};

    }
})();